import { BotAuthActivitySubscriber } from "./ActivitySubscriber/BotAuthActivitySubscriber";
import { ChatAdapterShim } from "./ChatAdapterShim";
import { HiddenAdaptiveCardActivitySubscriber } from "./ActivitySubscriber/HiddenAdaptiveCardActivitySubscriber";
import { MockChatSDK } from "../../webchatcontainerstateful/common/mockchatsdk";
import { NotificationHandler } from "../../webchatcontainerstateful/webchatcontroller/notification/NotificationHandler";
import { NotificationLevel } from "../../webchatcontainerstateful/webchatcontroller/enums/NotificationLevel";
import { NotificationScenarios } from "../../webchatcontainerstateful/webchatcontroller/enums/NotificationScenarios";
import { PauseActivitySubscriber } from "./ActivitySubscriber/PauseActivitySubscriber";
import { defaultMiddlewareLocalizedTexts } from "../../webchatcontainerstateful/common/defaultProps/defaultMiddlewareLocalizedTexts";
const defaultBotAuthConfig = {
  fetchBotAuthConfigRetries: 3,
  fetchBotAuthConfigRetryInterval: 1000
};
export const createAdapter = async (facadeChatSDK, props) => {
  const chatAdapterOptionalParams = {
    IC3Adapter: {
      options: {
        callbackOnNotification: notification => {
          if (notification.id === NotificationScenarios.InternetConnection && notification.level == NotificationLevel.Error) {
            notification.message = defaultMiddlewareLocalizedTexts.MIDDLEWARE_BANNER_NO_INTERNET_CONNECTION;
          }
          if (notification.id === NotificationScenarios.InternetConnection && notification.level == NotificationLevel.Success) {
            notification.message = defaultMiddlewareLocalizedTexts.MIDDLEWARE_BANNER_INTERNET_BACK_ONLINE;
          }
          if (notification.id && notification.message) {
            NotificationHandler.notifyWithLevel(notification.id, notification.message, notification.level);
          }
        }
      }
    },
    ACSAdapter: {
      fileScan: {
        disabled: false
      }
    }
  };
  let adapter = await facadeChatSDK.createChatAdapter(chatAdapterOptionalParams);
  //so far, there is no need to convert to the shim adapter when using visual tests
  const isMocked = facadeChatSDK.getChatSDK() instanceof MockChatSDK;
  if (isMocked !== true) {
    var _props$webChatContain, _props$webChatContain2, _props$webChatContain3, _props$webChatContain4;
    const botAuthActivitySubscriberOptionalParams = {
      fetchBotAuthConfigRetries: (props === null || props === void 0 ? void 0 : (_props$webChatContain = props.webChatContainerProps) === null || _props$webChatContain === void 0 ? void 0 : (_props$webChatContain2 = _props$webChatContain.botAuthConfig) === null || _props$webChatContain2 === void 0 ? void 0 : _props$webChatContain2.fetchBotAuthConfigRetries) || defaultBotAuthConfig.fetchBotAuthConfigRetries,
      fetchBotAuthConfigRetryInterval: (props === null || props === void 0 ? void 0 : (_props$webChatContain3 = props.webChatContainerProps) === null || _props$webChatContain3 === void 0 ? void 0 : (_props$webChatContain4 = _props$webChatContain3.botAuthConfig) === null || _props$webChatContain4 === void 0 ? void 0 : _props$webChatContain4.fetchBotAuthConfigRetryInterval) || defaultBotAuthConfig.fetchBotAuthConfigRetryInterval
    };
    adapter = new ChatAdapterShim(adapter);
    adapter.addSubscriber(new PauseActivitySubscriber());
    adapter.addSubscriber(new BotAuthActivitySubscriber(botAuthActivitySubscriberOptionalParams));
    // Remove this code after ICM ID:544623085 is fixed
    adapter.addSubscriber(new HiddenAdaptiveCardActivitySubscriber());
    return adapter.chatAdapter;
  }
  return adapter;
};